<template>
  <div class="container">
    <div
      class="flex mt12"
      v-for="(cItem, CIndex) in fItem.children"
      :key="cItem.name"
    >
      <div>任务内容</div>

      <el-select
        v-if="!cItem.isLogic"
        v-model="cItem.activityTaskType"
        placeholder="请选择任务内容"
        clearable
        @change="handleChange(cItem)"
        :style="{ width: '100%' }"
      >
        <el-option
          v-for="item in taskTypeMap[form.activityTaskModuleType]"
          :key="item.activityTaskName"
          :label="item.activityTaskFieldDesc"
          :value="item.activityTaskName"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="cItem.conditionType"
        placeholder="请选择操作符"
        clearable
        :disabled="cItem.activityTaskType === 'KycFinish'"
        :style="{ width: '100%' }"
      >
        <el-option
          v-for="(item, index) in cItem.isLogic
            ? logicOpListArr
            : mathOpListArr"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <div v-if="cItem.activityTaskType !== 'KycFinish'" style="width: 100%">
        <el-select
          v-if="!cItem.isLogic"
          v-model="cItem.coin"
          placeholder="请选择币种"
          clearable
          :style="{ width: '100%' }"
        >
          <el-option
            v-for="(item, index) in coinOptions2"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <el-select
        v-if="cItem.activityTaskType === 'KycFinish'"
        v-model="cItem.taskTypeArgs"
        placeholder="请选择状态"
        clearable
        @change="handleForceUpdate"
        :style="{ width: '100%' }"
      >
        <el-option
          v-for="(item, index) in [
            {
              label: '已完成',
              value: true,
            },
            {
              label: '未完成',
              value: false,
            },
          ]"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <div v-else style="width: 100%">
        <el-input
          v-if="!cItem.isLogic"
          v-model="cItem.taskTypeArgs"
          class="searchIpt"
          placeholder="数量"
          @input="handleForceUpdate"
        ></el-input>
      </div>
      <div class="addTask">
        <el-button
          v-if="cItem.isLogic"
          size="mini"
          type="primary"
          @click="handleAddTask(cItem.children, false)"
          >添加任务</el-button
        >
        <!-- <el-button
          v-if="cItem.isLogic"
          size="mini"
          type="primary"
          @click="handleAddTask(cItem.children, true)"
          >添加逻辑任务</el-button
        > -->
        <el-button
          size="mini"
          type="primary"
          @click="handleDelTask(cItem, CIndex, fItem.children)"
          >删除任务</el-button
        >
      </div>

      <TaskList
        v-if="cItem.children && cItem.children.length"
        @handleAddTask="handleAddTask"
        @handleDelTask="handleDelTask"
        :fItem="cItem"
        :form="form"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'TaskList',
  props: ['fItem', 'form', 'activityTaskModuleType'],
  data() {
    return {
      coinOptions2: [
        {
          label: 'USDT',
          value: 0,
        },
      ],
      iform: this.form,
    }
  },
  computed: {
    ...mapState('management', ['taskTypeList', 'lotteryList']),
    ...mapGetters('management', [
      'mathOpListArr',
      'taskTypeMap',
      'logicOpListArr',
    ]),
  },

  methods: {
    handleForceUpdate() {
      this.$forceUpdate()
    },
    handleAddTask(cItem, isLogic) {
      this.$emit('handleAddTask', cItem, isLogic)
    },
    handleDelTask(cItem, index, arr) {
      this.$emit('handleDelTask', index, cItem, arr)
    },
    handleChange(item) {
      item.taskTypeArgs = ''
      item.conditionType = ''

      if (item.activityTaskType === 'KycFinish') {
        item.conditionType = 'EQ'
        item.taskTypeArgs = ''
      }
      this.$forceUpdate()
    },
  },
}
</script>
<style lang="less" scoped>
.langTab {
  cursor: pointer;
  margin-right: 20px;
  display: inline-block;
}
.container {
}

.flex {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  border: 1px solid #1e1e1e;
  padding: 12px;
}
.mt12 {
  margin-top: 12px;
}
.addTask {
}
</style>
